export const NOTIFICATIONS = "NOTIFICATIONS";
export const NOTIFICATIONS_BUSY = "NOTIFICATIONS_BUSY";
export const NOTIFICATIONS_COUNT = "NOTIFICATIONS_COUNT";
export const NOTIFICATIONS_SETUP = "NOTIFICATIONS_SETUP";
export const NOTIFICATIONS_SETUP_COUNT = "NOTIFICATIONS_SETUP_COUNT";
